import { render, staticRenderFns } from "./ListKlaimPd.vue?vue&type=template&id=430d107e&"
import script from "./ListKlaimPd.vue?vue&type=script&lang=js&"
export * from "./ListKlaimPd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports